<template>
    <div class="bookend-header nav-container">
        <nav class="navbar fixed-top navbar-expand-md navbar-light bg-white">
            <div class="container">
                <a href="https://www.payformytrip.com" class="navbar-brand">
                    <img
                        v-if="brandedLogoError === false && link !== null && trip !== null && link.audience === 'AGENT'"
                        class="logo branded"
                        :src="getBrandedLogoPath()"
                        alt="Pay For My Trip Logo"
                        @error="brandedLogoError = true"
                    />
                    <img
                        v-else
                        class="logo"
                        src="@/assets/images/logo.svg"
                        alt="Pay For My Trip Logo"
                    />
                </a>
                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#HeaderNavBar"
                    aria-controls="HeaderNavBar"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <font-awesome-icon :icon="['fal', 'bars']" />
                </button>

                <div class="collapse navbar-collapse justify-content-end" id="HeaderNavBar">
                    <ul class="navbar-nav align-items-center">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link text-uppercase">{{$t('find.pageTitle')}}</router-link>
                            <div class="nav-line"></div>
                        </li>
                        <li class="nav-item">
                            <a :href="$config.urls.about" class="nav-link text-uppercase">{{$t('common.bookend.about')}}</a>
                            <div class="nav-line"></div>
                        </li>
                        <li class="nav-item d-md-none">
                            <small>
                                <locale-selector class="text-dark"/>
                            </small>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import LocaleSelector from "@/components/common/LocaleSelector";
export default {
    name: 'BookendHeader',
    components: {LocaleSelector},
    data() {
        return {
            brandedLogoError: false
        }
    },
    computed: {
        link() {
            return this.$store.state.link;
        },
        trip() {
            return this.$store.state.trip;
        }
    },
    methods: {
        getBrandedLogoPath() {
            try {
                return require(`@/assets/images/logo-${this.trip.brand.abbreviatedCompany}.svg`);
            } catch(e) {
                this.brandedLogoError = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .navbar {
        min-height: 110px; //Makes sure header doesn't change height if logo is slow to load.
        box-shadow: 1px 2px 4px rgb(0 0 0 / 15%);
        .logo {
            width: 15rem;
            &.branded {
                width: 19.8rem;
            }
        }

        .navbar-toggler {
            color: $navbar-light-toggler-border-color;
            &:focus {
                box-shadow: 0 0 $input-btn-focus-blur $navbar-toggler-focus-width rgba($navbar-light-toggler-border-color, $input-btn-focus-color-opacity);
            }
        }

        .nav-item {
            position: relative;
            margin: 0 0.75rem;
            font-weight: 600;
            a {
                padding: 0.75rem 0;

                position: relative;
                color: $dark;
                text-decoration: none;
                &.router-link-exact-active {
                    & + .nav-line {
                        width: 100%;
                    }
                }
            }
            .nav-line {
                transition: all 300ms cubic-bezier(0.175,0.885,0.32,1.275);
                overflow: hidden;
                position: absolute;
                pointer-events: none;
                left: 1px;
                bottom: 8px;
                display: block;
                width: 0;
                height: 2px;
                max-height: 2px;
                background: $secondary;
            }
            &:hover {
                a {
                    color: $secondary;
                }

                .nav-line {
                    width: 100%;
                }
            }
        }
    }

    //Styles the small breakpoint and smaller.
    @include media-breakpoint-down(sm) {
        .navbar {
            min-height: 82px; //Makes sure header doesn't change height if logo is slow to load.
            .logo {
                width: 10rem;
                &.branded {
                    width: 13rem;
                }
            }
        }
    }
</style>